import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { GLViewRow } from "../glViewTypes";
import styles from "../GeneralLedgerTable.module.scss";

export const GLExcludeFrom1099Cell = React.memo(function GLExcludeFrom1099Cell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell className={styles.centeredCell}>
            {transaction.excludeFrom1099 ? "Yes" : "No"}
        </ViewTableCell>
    );
});
